const firebaseConfig = {
    // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    // authDomain:process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ,
    // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ,
    // appId:process.env.REACT_APP_FIREBASE_APP_ID
    apiKey: "AIzaSyA5LkL84GHdM30PG55_6SxJAtom4TmSu10",
    authDomain: "travel-goro.firebaseapp.com",
    projectId: "travel-goro",
    storageBucket: "travel-goro.appspot.com",
    messagingSenderId: "725666925615",
    appId: "1:725666925615:web:d1eb00fcd74c93fb32cada"
};

export default firebaseConfig;